import type { IExpenseProperty } from './ExpenseProperty.interface';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export default class ExpenseProperty implements IExpenseProperty {
  currentRental: number;
  currentRentalFrequency: PaymentFrequency;
  currentRentalComments: string;
  homeAndContentsInsurance: number;
  homeAndContentsInsuranceFrequency: PaymentFrequency;
  homeAndContentsInsuranceComments: string;
  ratesBodyCorpOwnerOccupied: number;
  ratesBodyCorpOwnerOccupiedFrequency: PaymentFrequency;
  ratesBodyCorpOwnerOccupiedComments: string;
  electricityGasWater: number;
  electricityGasWaterFrequency: PaymentFrequency;
  electricityGasWaterComments: string;
  repairsMaintenancePool: number;
  repairsMaintenancePoolFrequency: PaymentFrequency;
  repairsMaintenancePoolComments: string;
  ratesBodyCorpInvestment: number;
  ratesBodyCorpInvestmentFrequency: PaymentFrequency;
  ratesBodyCorpInvestmentComments: string;

  static build = (data: IExpenseProperty) => new ExpenseProperty(data);
  static blank = () => new ExpenseProperty();

  /**
   * Constructor
   * @param {IExpenseProperty} data
   */
  constructor(data?: IExpenseProperty) {
    this.currentRental = parseFloat(data?.currentRental || 0);
    // TODO: data?.currentRentalFrequency is legacy data structure
    this.currentRentalFrequency = data?.currentRentalFrequency
      ? PaymentFrequency.of(
          data?.currentRentalFrequency?.name || data?.currentRentalFrequency.toString()
        )
      : PaymentFrequency.weekly;
    this.currentRentalComments = data?.currentRentalComments || '';
    this.homeAndContentsInsurance = parseFloat(data?.homeAndContentsInsurance || 0);
    // TODO: data?.homeAndContentsInsuranceFrequency is legacy data structure
    this.homeAndContentsInsuranceFrequency = data?.homeAndContentsInsuranceFrequency
      ? PaymentFrequency.of(
          data?.homeAndContentsInsuranceFrequency?.name ||
            data?.homeAndContentsInsuranceFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.homeAndContentsInsuranceComments = data?.homeAndContentsInsuranceComments || '';
    this.ratesBodyCorpOwnerOccupied = parseFloat(data?.ratesBodyCorpOwnerOccupied || 0);
    // TODO: data?.ratesBodyCorpOwnerOccupiedFrequency is legacy data structure
    this.ratesBodyCorpOwnerOccupiedFrequency = data?.ratesBodyCorpOwnerOccupiedFrequency
      ? PaymentFrequency.of(
          data?.ratesBodyCorpOwnerOccupiedFrequency?.name ||
            data?.ratesBodyCorpOwnerOccupiedFrequency.toString()
        )
      : PaymentFrequency.quarterly;
    this.ratesBodyCorpOwnerOccupiedComments = data?.ratesBodyCorpOwnerOccupiedComments || '';
    this.electricityGasWater = parseFloat(data?.electricityGasWater || 0);
    // TODO: data?.electricityGasWaterFrequency is legacy data structure
    this.electricityGasWaterFrequency = data?.electricityGasWaterFrequency
      ? PaymentFrequency.of(
          data?.electricityGasWaterFrequency?.name ||
            data?.electricityGasWaterFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.electricityGasWaterComments = data?.electricityGasWaterComments || '';
    this.repairsMaintenancePool = parseFloat(data?.repairsMaintenancePool || 0);
    // TODO: data?.repairsMaintenancePoolFrequency is legacy data structure
    this.repairsMaintenancePoolFrequency = data?.repairsMaintenancePoolFrequency
      ? PaymentFrequency.of(
          data?.repairsMaintenancePoolFrequency?.name ||
            data?.repairsMaintenancePoolFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.repairsMaintenancePoolComments = data?.repairsMaintenancePoolComments || '';
    this.ratesBodyCorpInvestment = parseFloat(data?.ratesBodyCorpInvestment || 0);
    // TODO: data?.ratesBodyCorpInvestmentFrequency is legacy data structure
    this.ratesBodyCorpInvestmentFrequency = data?.ratesBodyCorpInvestmentFrequency
      ? PaymentFrequency.of(
          data?.ratesBodyCorpInvestmentFrequency?.name ||
            data?.ratesBodyCorpInvestmentFrequency.toString()
        )
      : PaymentFrequency.quarterly;
    this.ratesBodyCorpInvestmentComments = data?.ratesBodyCorpInvestmentComments || '';
  }
}
